<template>
  <div class="">
    <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      class="dialogClass"
      title="订单详情"
      width="70%"
    >
      <el-divider content-position="left">订单信息</el-divider>

      <el-row :gutter="20">
        <el-col :span="12" class="cus_mar"
          >订单编号：{{ editForm.orderCode || "/" }}</el-col
        >
        <el-col :span="12" class="cus_mar"
          >创建人：{{ editForm.createUserName || "/" }}</el-col
        >
        <el-col :span="12" class="cus_mar"
          >联系方式：{{ editForm.createUserPhone || "/" }}</el-col
        >
        <el-col :span="12" class="cus_mar"
          >收货人：{{ editForm.name || "/" }}</el-col
        >
        <el-col :span="12" class="cus_mar"
          >收货电话：{{ editForm.phone || "/" }}</el-col
        >
        <el-col :span="12" class="cus_mar"
          >省市区：{{ editForm.province || "/" }}-{{ editForm.city || "/" }}-{{
            editForm.county || "/"
          }}
        </el-col>
        <el-col :span="12" class="cus_mar"
          >详细地址：{{ editForm.address || "/" }}</el-col
        >
        <el-col :span="12" class="cus_mar"
          >商品总价：{{ editForm.allPrice || "/" }}</el-col
        >
        <el-col :span="12" class="cus_mar"
          >实付款：{{ editForm.realPayment || "/" }}</el-col
        >
        <el-col :span="12" class="cus_mar"
          >创建时间：{{ editForm.createTime || "/" }}</el-col
        >
        <el-col :span="12" class="cus_mar"
          >付款时间：{{ editForm.payTime || "/" }}</el-col
        >

        <el-col :span="12" class="cus_mar"
          >订单状态：
          <span v-if="editForm.orderType == 0">待支付</span>
          <span v-if="editForm.orderType == 1">待发货</span>
          <span v-if="editForm.orderType == 2">待收货</span>
          <span v-if="editForm.orderType == 3">已完成</span>
          <span v-if="editForm.orderType == 4">退款中</span>
          <span v-if="editForm.orderType == 5">已退款</span>
          <span v-if="editForm.orderType == 6">拒绝退款</span>
          <span v-if="editForm.orderType == 7">取消订单</span>
          <span v-if="editForm.orderType == 8">拼团已过期</span>
          <span v-if="editForm.orderType == 9">待抽奖</span>
          <span v-if="editForm.orderType == 10">捡货中</span>
          <span v-if="editForm.orderType == 11">待取货</span>
          <span v-if="editForm.orderType == -1">已支付</span>
        </el-col>
        <el-col :span="12" class="cus_mar" v-if="editForm.orderType == 5"
          >退款时间：{{ editForm.refundTime || "/" }}</el-col
        >
        <el-col :span="12" class="cus_mar" v-if="editForm.orderType == 5"
          >退款金额：{{ editForm.refundAmount || "/" }}</el-col
        >
        <el-col :span="12" class="cus_mar"
          >优惠券名称：{{ editForm.couponNameList || "/" }}</el-col
        >
        <el-col :span="12" class="cus_mar"
          >优惠券金额：{{ editForm.couponMoney || "0" }}</el-col
        >
        <el-col v-if="editForm.isGroupBuying == 1" :span="12" class="cus_mar"
          >拼团状态：
          <span v-if="editForm.isGroupBuyingSuccess == 1">拼团成功</span>
          <span
            v-if="editForm.orderType == 1 && editForm.isGroupBuyingSuccess == 0"
            >拼团中</span
          >
          <span v-if="editForm.orderType == 8">拼团失败</span>

          <span></span>
        </el-col>
        <el-col v-if="editForm.isCrowdfunding == 1" :span="12" class="cus_mar">
          <span>众筹订单</span>
        </el-col>
        <el-col :span="12" class="cus_mar"
          >支付方式：{{
            editForm.offlinePayment == 0
              ? "余额支付"
              : editForm.offlinePayment == 1
              ? "银行卡支付"
              : editForm.offlinePayment == 2
              ? "微信支付"
              : ""
          }}
        </el-col>
        <el-col :span="12" class="cus_mar"
          >归属仓库：{{ editForm.entrepotName }}</el-col
        >
        <el-col :span="12" class="cus_mar"
          >是否达人码下单：
          <span>{{ editForm.tstoreId ? "是" : "否" }}</span></el-col
        >
        <el-col :span="12" class="cus_mar" v-if="editForm.tstoreId"
          >达人名称： <span>{{ storeName }}</span></el-col
        >
      </el-row>
      <el-row v-if="editForm.invoiceImageUrl" :gutter="20">
        <el-divider content-position="left">发票信息</el-divider>
        <el-col class="cus_mar" style="width: 100px">发票图片</el-col>
        <el-col class="cus_mar" style="width: 100px">
          <el-image
            v-if="editForm.invoiceImageUrl"
            :preview-src-list="[editForm.invoiceImageUrl]"
            :src="editForm.invoiceImageUrl"
            style="width: 60px; height: 60px"
          ></el-image>
        </el-col>
        <el-col class="cus_mar" style="width: 100px">
          <el-button
            icon="el-icon-view"
            type="primary"
            size="mini"
            @click="downloadPdf"
            >查看pdf</el-button
          >
        </el-col>
      </el-row>
      <el-row
        v-for="(item, index) in editForm.tcommodityVos"
        :key="index"
        :gutter="20"
      >
        <el-divider content-position="left">商品信息{{ index + 1 }}</el-divider>
        <el-col :span="12" class="cus_mar"
          >商品名称：{{ item.name || "/" }}</el-col
        >
        <el-col :span="12" class="cus_mar"
          >商品规格：{{ item.commoditSpecifications || "/" }}</el-col
        >
        <el-col :span="8" class="cus_mar">原价：{{ item.price || "/" }}</el-col>
        <el-col :span="8" class="cus_mar"
          >{{ item.sellingPriceName || "售价" }}：{{
            editForm.tstoreId ? item.storeGoodsSellingPrice : item.money || "/"
          }}</el-col
        >
        <el-col :span="8" class="cus_mar"
          >{{ item.storePriceName || "达人价" }}：{{
            editForm.tstoreId ? item.money : item.storeGoodsSellingPrice || "/"
          }}</el-col
        >
        <el-col :span="8" class="cus_mar"
          >商品数量：{{ item.number || "/" }}</el-col
        >
        <el-col :span="8" class="cus_mar"
          >发货时间：{{ item.logisticsTime || "/" }}</el-col
        >
        <el-col v-if="item.logisticsNumber" :span="8" class="cus_mar"
          >物流单号：
          <span class="cusp conend" @click="logs(item)">{{
            item.logisticsNumber || "/"
          }}</span>
        </el-col>
        <el-col v-if="item.logisticsNumbers" :span="8" class="cus_mar"
          >物流单号：
          <span class="cusp">{{ item.logisticsNumbers || "/" }}</span>
        </el-col>
        <el-col v-if="item.carName" :span="8" class="cus_mar"
          >司机姓名：<span>{{ item.carName || "/" }}</span></el-col
        >
        <el-col v-if="item.carPhone" :span="8" class="cus_mar"
          >司机联系方式：<span>{{ item.carPhone || "/" }}</span></el-col
        >
        <el-col v-if="item.carNum" :span="8" class="cus_mar"
          >车牌号：<span>{{ item.carNum || "/" }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="editForm.isException == 1">
        <el-divider content-position="left">订单异常</el-divider>
        <el-col :span="24" class="cus_mar">
          <el-row v-if="editForm.exceptionImg">
            <el-col style="width: 80px">附件:</el-col>
            <el-col style="width: calc(100% - 120px)">
              <el-image
                v-for="(item, index) in editForm.exceptionImg.split(',')"
                :key="index"
                style="width: 60px; height: 60px; margin-right: 20px"
                :src="item"
                :preview-src-list="editForm.exceptionImg.split(',')"
              >
              </el-image>
            </el-col>
          </el-row>
          <el-row>
            <el-col style="width: 80px">异常备注:</el-col>
            <el-col style="width: calc(100% - 120px)">
              {{ editForm.exceptionMsg }}
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row v-if="editForm.isGroupBuying == 1" :gutter="20">
        <el-divider content-position="left">拼团人员</el-divider>

        <el-col :span="6" class="cus_mar"
          >拼团所需人数：
          <span class="cusp">{{ editForm.groupBuyingNum || "/" }}</span>
        </el-col>
        <el-col :span="6" class="cus_mar"
          >实际拼团人数：
          <span class="cusp">{{
            editForm.tcommodityUserVos.length || "/"
          }}</span>
        </el-col>
        <el-col :span="6" class="cus_mar"
          >拼团自动补充人数：
          <span class="cusp">{{
            editForm.groupBuyingNum - editForm.tcommodityUserVos.length || "/"
          }}</span>
        </el-col>
        <el-col :span="24" class="cus_mar">
          <div style="display: flex; align-items: center; text-align: center">
            <div v-for="(i, n) in editForm.tcommodityUserVos" :key="n">
              <el-image
                :src="i.cover ? i.cover : ''"
                style="width: 60px; height: 60px; border-radius: 60px"
              ></el-image>
              <div class="box_hid">{{ i.name }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-divider content-position="left">商家订单备注</el-divider>
        <el-col :span="24" class="cus_mar">
          <el-row>
            <el-col style="width: 80px">备注</el-col>
            <el-col style="width: calc(100% - 120px)">
              <el-input
                v-model="editForm.remark"
                :rows="4"
                placeholder="请输入内容"
                type="textarea"
              >
              </el-input>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div style="text-align: center; margin-top: 60px">
        <el-button plain type="primary" @click="ddbz()"> 提交 </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="'物流详情'"
      :visible.sync="visible"
      append-to-body
      class="dialogClass"
      width="700px"
    >
      <div v-if="wuliutype == 1">
        <el-steps :active="0" direction="vertical">
          <el-step
            v-for="(items, indexs) in listaudio"
            :key="indexs"
            :description="`${items.acceptTime || ''}`"
            :title="`${items.statusName || ''}`"
          ></el-step>
        </el-steps>
      </div>
      <div v-if="wuliutype == 2">
        <el-steps :active="0" direction="vertical">
          <el-step
            v-for="(items, indexs) in listaudio.steps"
            :key="indexs"
            :description="`${items.time || ''}`"
            :title="`${items.description || ''}`"
          ></el-step>
        </el-steps>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VploadVideo from "../inc/VploadVideo.vue";
import TinymceEditor from "../inc/TinymceEditor";

export default {
  name: "BillDetails",
  components: {
    TinymceEditor,
    VploadVideo,
  },
  data() {
    return {
      wuliutype: 1,
      editForm: {},
      fileList: [],
      tableData: [],
      urlList: [],
      videoList: [],
      radio: 0,
      storeName: "",
      videoUrlList: [],
      infoyent: "",
      editFormRules: {
        value: [
          {
            required: true,
            message: "请选择群二维码",
            trigger: "blur",
          },
        ],
      },
      dialogVisible: false,
      visible: false,
      listaudio: [],
    };
  },
  methods: {
    downloadPdf() {
      // 创建隐藏的下载链接
      const link = document.createElement("a");
      link.href = this.editForm.invoiceFileUrl;
      link.target = "_blank";
      link.download = this.fileName;

      // 触发下载
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 错误处理
      link.addEventListener("error", (e) => {
        console.error("下载失败:", e);
        this.$emit("download-error", e);
      });
    },
    change(val) {
      this.editForm.describe = val;
    },
    logs(i) {
      if (i.logisticsType == 3) {
        this.$axios
          .post("/admin/order/getYDLogistics", {
            trackingNumber: i.logisticsNumber,
          })
          .then((res) => {
            res.data.data.steps = res.data.data.steps.reverse();
            this.listaudio = res.data.data || [];
            this.wuliutype = 2;

            if (res.code == 0) {
              this.visible = true;
            }
          });
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.editForm = {};
      this.fileList = [];
      this.urlList = [];
      this.tableData = [];
      this.videoList = [];
      this.videoUrlList = [];
    },
    handleClose() {
      this.resetForm("editForm");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post(
              "/admin/mcMuseumCollection/updMcMuseumCollectionDetails",
              this.editForm
            )
            .then((res) => {
              this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
                onClose: () => {
                  this.$emit("refreshDataList");
                },
              });
              this.dialogVisible = false;
              this.resetForm(formName);
            });
        } else {
          return false;
        }
      });
    },
    getImgList(url, add) {
      if (add == 1) {
        this.urlList.push(url);
      } else if (add == 0) {
        if (this.urlList == null || this.urlList.length < 1) {
          return;
        }
        this.urlList.some((item, i) => {
          if (item == url) {
            this.urlList.splice(i, 1);
            return true;
          }
        });
      }
      this.editForm.filePath = this.urlList.join(",");
    },
    ddbz() {
      this.$axios
        .post("/admin/order/addRemark", {
          orderCode: this.editForm.orderCode,
          remark: this.editForm.remark,
        })
        .then((res) => {
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
          });
        });
    },
    init(val) {
      this.dialogVisible = true;
      this.radio = 0;
      this.storeName = val.storeName;
      if (val.orderCode != null && val.orderCode != "") {
        this.$axios
          .post("/admin/order/getOrderDetail", {
            orderCode: val.orderCode,
          })
          .then((res) => {
            this.editForm = res.data;
            this.tableData = res.data.tcommodityVos;
          });
      }
    },
  },
};
</script>

<style scoped>
.flexjcen {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flexcen {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.store {
  width: 60px;
  height: 60px;
  border-radius: 6px;
}

.godwin {
  padding-left: 10px;
}

.sizetxt {
  height: 40px;
  line-height: 20px;
  font-size: 14px;
}

.red {
  color: #d9001b;
  font-weight: 800;
  font-size: 16px;
}

.issline {
  height: 1px;
  background: #e1e1e1;
  width: 100%;
}

.redmony {
  color: #d9001b;
  font-size: 16px;
}

.titcon {
  width: 150px;
}

.cusp {
  cursor: pointer;
}

.conend {
  color: #4293fe;
}

.cus_mar {
  margin-bottom: 20px;
}

.box_hid {
  width: 100px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
